"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmbeddedContentProperty = exports.embeddedContentPropertyDefinition = void 0;
exports.embeddedContentPropertyDefinition = {
    view: { label: 'Related content' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: ['embedded-content-title', 'embedded-content-asset'],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'embedded-content',
};
const isEmbeddedContentProperty = (prop) => {
    return prop.name === exports.embeddedContentPropertyDefinition.name;
};
exports.isEmbeddedContentProperty = isEmbeddedContentProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW1iZWRkZWQtY29udGVudC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2VtYmVkZGVkLWNvbnRlbnQucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxpQ0FBaUMsR0FBRztJQUMvQyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsaUJBQWlCLEVBQUU7SUFDbEMsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsbUJBQW1CO1lBQ3pCLFFBQVEsRUFBRSxDQUFDLHdCQUF3QixFQUFFLHdCQUF3QixDQUFDO1NBQy9EO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsbUJBQW1CO0lBQ3pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLGtCQUFrQjtDQUNPLENBQUE7QUFJMUIsTUFBTSx5QkFBeUIsR0FBRyxDQUFDLElBQWtCLEVBQW1DLEVBQUU7SUFDL0YsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHlDQUFpQyxDQUFDLElBQUksQ0FBQTtBQUM3RCxDQUFDLENBQUE7QUFGWSxRQUFBLHlCQUF5Qiw2QkFFckMifQ==